import {PaymentMethodsDTO} from "@app/core/payment-method/application/payment-methods-dto";
import {Observable} from "rxjs";

export abstract class PaymentMethodsDTOFinder {
    abstract find(): Observable<PaymentMethodsDTO>;
}